import styled from 'styled-components';

export const ConsumerJourneyMapStyles = styled.div`
  font-family: 'Montserrat';
  position: relative;
  overflow: hidden;

  .container {
    max-width: 1190px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 0 10px;
    margin: 0 auto;
    position: relative;

    @media (max-width: 991px) {
      flex-direction: column;
      gap: 15px;
    }

    h5 {
      font-weight: 700;
      font-size: 18px;
      line-height: 120%;
      background: linear-gradient(180deg, #FDA272 0%, #F15967 100%);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    h2 {
      font-weight: 700;
      font-size: 40px;
      line-height: 120%;
      color: #000000;

      @media (max-width: 768px) {
        font-size: 28px;
      }
    }

    .content {
      max-width: 770px;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 25px;

      @media (max-width: 991px) {
        max-width: none;
      }
    }
  }

  .btn-container {
    display: flex;
    width: 100%;
    margin-top: 50px;
    justify-content: center;
  }
`;
